export default __webpack_public_path__ + "static/media/12_a._dreamer.e76650b3.png";